import { Trans } from 'next-i18next';
import React from 'react';
import { NavLink } from '@/components/local/NavLink/NavLink';
import { ProductConfig, productsConfig } from '@/data/productsConfig';
import { getCountryConfigFromLocale } from '@/lib/i18n/getCountryConfigFromLocale';
import { formatPrice } from '@/utils/formatPrice';
import { HEAVY_USE_FEE } from '../HeavyUser/HeavyUser';
import styles from './HeavyUseDisabledLabel.module.scss';

interface Props {
  currency: string;
  locale: string;
  productId: ProductConfig['id'];
}

export const HeavyUseDisabledLabel = ({
  currency,
  locale,
  productId,
}: Props) => {
  const { countryCode } = getCountryConfigFromLocale(locale!);

  if (productId) {
    return (
      <Trans
        components={{
          navLink: (
            <NavLink
              target="_blank"
              id={styles.navLink}
              link={{
                type: 'local',
                url: `/bikes/${productId}`,
                key: productId,
              }}
            >
              link
            </NavLink>
          ),
        }}
        i18nKey={`pages:configure.heavyUser.disabled.${productsConfig[productId].translationKey}`}
      />
    );
  }

  return (
    <Trans
      i18nKey="pages:configure.heavyUser.penalty"
      values={{
        fee: formatPrice(
          HEAVY_USE_FEE[countryCode] ?? HEAVY_USE_FEE.default,
          locale!,
          currency,
          false
        ),
      }}
    />
  );
};
